export function warningText(cell) {
  const rest = cell.lastRest ? new Date(cell.lastRest + 'T12:00:00').toLocaleDateString('es-UY', { weekday: 'long', day: 'numeric', month: 'numeric' }) : 'sin registro previo; el conteo puede ser mayor';
  return `Último día de descanso: ${rest}${cell.streak >= 7 ? `\n${cell.streak} días consecutivos sin descanso (según planificación).` : ''}`;
}
export function cellText(cell) {
  if (!cell.working) return cell.status === 'VACIO' ? 'VACÍO' : cell.status;
  return cell.shifts.filter(s => s.estado === 'NORMAL').map(s => [[s.hora_inicio, s.hora_fin].filter(Boolean).join(' - '), s.actividad_ubicacion, s.ubicacion_corta || s.ubicacion].filter(Boolean).join(' · ')).join('\n');
}
export async function exportMonthlyPlan(data, { colored, view }) {
  const ExcelJS = await import('exceljs');
  const workbook = new (ExcelJS.default || ExcelJS).Workbook();
  const sheet = workbook.addWorksheet('Control', { views: [{ state: 'frozen', xSplit: 1, ySplit: 3 }] });
  sheet.addRow([`Control · ${data.from} a ${data.to} · ${view === 'month' ? 'Vista mensual' : 'Vista por día'}`]);
  sheet.addRow(['Jornadas previstas. ' + (colored ? 'Verde 1–5 · Amarillo 6 · Rojo 7 o más. Vacíos no acreditan descanso.' : 'Rango manual sin control de colores.')]);
  sheet.addRow(['Persona', ...data.days.map(d => d.split('-').reverse().join('/'))]);
  sheet.getColumn(1).width = 26;
  data.days.forEach((_, i) => { sheet.getColumn(i + 2).width = view === 'month' ? 14 : 27; });
  for (const person of data.rows) {
    const row = sheet.addRow([person.nickname || [person.first_name, person.last_name].filter(Boolean).join(' '), ...person.days.map(cellText)]);
    row.height = view === 'month' ? 78 : 58;
    row.eachCell((cell, col) => {
      cell.alignment = { vertical: 'middle', horizontal: col === 1 ? 'left' : 'center', wrapText: true };
      cell.border = { bottom: { style: 'thin', color: { argb: 'FFD1D5DB' } }, right: { style: 'thin', color: { argb: 'FFD1D5DB' } } };
      const day = person.days[col - 2];
      if (colored && day?.working) {
        const red = ['FFFEE2E2', 'FFFECACA', 'FFFCA5A5', 'FFF87171', 'FFEF4444', 'FFDC2626'];
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: day.level === 'ok' ? 'FFDCFCE7' : day.level === 'warning' ? 'FFFEF3C7' : red[day.severity] } };
        if (day.showWarning) cell.note = warningText(day);
      }
    });
  }
  sheet.getRow(3).eachCell(cell => { cell.font = { bold: true, color: { argb: 'FF1F2937' } }; cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE5E7EB' } }; });
  sheet.autoFilter = { from: { row: 3, column: 1 }, to: { row: 3, column: data.days.length + 1 } };
  const buffer = await workbook.xlsx.writeBuffer();
  const url = URL.createObjectURL(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
  const link = document.createElement('a'); link.href = url; link.download = `Control-${data.from}-${data.to}.xlsx`; document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
